import type { ErrorConfig } from '#types/config/pages/error'
import type { RecursivePartial } from '#types/utils'

export default {
  hideLayoutOnStatusCode: [401, 403, 500]
} satisfies RecursivePartial<ErrorConfig>
